import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import '../styles/BlogsPage.css';

export default function ContactPage() {
  return (
    <div className="blogs-page">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg blogs-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/sidebar-logo.png" alt="MeetingPoint Logo" loading="lazy" />
          </Link>
          <div className="d-flex align-items-center gap-3">
            <Link to="/blogs" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-newspaper me-2"></i>Blog
            </Link>
            <Link to="/" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-arrow-left me-2"></i>Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Header */}
      <header className="blog-detail-hero">
        <div className="container">
          <h1 className="blog-detail-title">Contact Us</h1>
          <p className="blog-detail-excerpt">Have a question or want to collaborate? We'd love to hear from you.</p>
        </div>
      </header>

      {/* Content */}
      <article className="container blog-detail-content">
        <div className="blog-detail-body privacy-body">
          <p>
            Have a question about MeetingPoint or interested in collaborating? We're always looking to connect with fellow privacy enthusiasts and developers.
          </p>

          <h3>Get In Touch</h3>
          <div style={{ background: 'rgba(255, 255, 255, 0.04)', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: '12px', padding: '2rem', marginBottom: '2rem' }}>
            <p style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#eee' }}><i className="fas fa-envelope me-2" style={{ color: '#ff5574' }}></i>General Inquiries:</strong>{' '}
              <a href="mailto:admin@meetingpoint.chat" className="text-decoration-underline">admin@meetingpoint.chat</a>
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#eee' }}><i className="fas fa-headset me-2" style={{ color: '#ff5574' }}></i>Technical Support:</strong>{' '}
              <a href="mailto:support@meetingpoint.chat" className="text-decoration-underline">support@meetingpoint.chat</a>
            </p>
            <p style={{ marginBottom: '0' }}>
              <strong style={{ color: '#eee' }}><i className="fas fa-clock me-2" style={{ color: '#ff5574' }}></i>Response Time:</strong>{' '}
              <span style={{ marginBottom: '0', color: '#aaa' }}>We typically respond to all inquiries within 48 business hours.</span>
            </p>
          </div>

          <h3>About Our Team</h3>
          <p>
            We are a fully remote team of developers and privacy enthusiasts focused on building decentralized communication tools. MeetingPoint is our answer to the growing demand for private, accountless communication in 2026.
          </p>

          <h3>Report a Bug</h3>
          <p>
            Found something that doesn't work quite right? We appreciate detailed bug reports. When reaching out, please include:
          </p>
          <ul>
            <li>Your browser name and version</li>
            <li>Your operating system</li>
            <li>A description of what happened vs. what you expected</li>
            <li>Steps to reproduce the issue (if possible)</li>
          </ul>

          <h3>Feature Requests</h3>
          <p>
            Got a bug? A suggestion? Or just want to tell us how much you hate account-walls? Drop us a line at{' '}
            <a href="mailto:admin@meetingpoint.chat" className="text-decoration-underline">admin@meetingpoint.chat</a>. We actually read our emails.
          </p>
        </div>
      </article>

      {/* Footer */}
      <footer className="blogs-footer">
        <div className="container text-center">
          <p className="mb-1">&copy; {new Date().getFullYear()} MeetingPoint. All rights reserved.</p>
          <div className="d-flex justify-content-center gap-3 mt-2 flex-wrap">
            <Link to="/" className="text-muted">Home</Link>
            <Link to="/about" className="text-muted">About</Link>
            <Link to="/blogs" className="text-muted">Blog</Link>
            <Link to="/faq" className="text-muted">FAQ</Link>
            <Link to="/privacy" className="text-muted">Privacy Policy</Link>
            <Link to="/terms" className="text-muted">Terms</Link>
            <Link to="/disclaimer" className="text-muted">Disclaimer</Link>
          </div>
        </div>
      </footer>
      <ScrollToTop />
    </div>
  );
}
